export default {
  'confirm-yes': 'Sí, confirmo',
  copay: 'Copago:',
  cancel: 'Cancelar',
  'order-status': 'Estado del pedido:',
  'order-canceled': 'Pedido cancelado',
  'confirmed-back-to-pharmacy': 'Devolución a la farmacia confirmada',
  'on-its-way-to-pharmacy': 'En camino a la farmacia',
  'back-to-pharmacy': 'Devuelto a la farmacia',
  'patient-signature': 'Firma del paciente',
  sign: 'Firmar',
  'select-order-type': 'Seleccione el tipo de pedido',
  'preferred-eta': 'Hora de entrega preferida',
  'recipient-instructions': 'Instrucciones especiales del destinatario',
  'add-special-instruction': 'Agregar instrucción especial',
  'unable-to-change-address': 'No se pudo cambiar la dirección',
  'address-changed': 'Dirección cambiada correctamente',
  'start-typing': 'Empiece a escribir',
  'full-address': 'Dirección completa',
  'street-address': 'Calle',
  zip: 'Código postal',
  city: 'Ciudad',
  state: 'Estado',
  apt: 'Apto',
  'app-store': 'Descargar en App Store',
  'track-all-orders': 'Siga todos sus pedidos en una sola app',
  zoom: 'acercar',
  unzoom: 'alejar',
  'close-photo': 'cerrar',
  'feedback-call': 'Llamada',
  'feedback-message': 'Mensaje',
  'feedback-close': 'Cerrar',
  close: 'Cerrar',
}
